export const DROPDOWN_BTN = {
  driver: 'Водій',
  forwarder: 'Експедитор',
  vehicle: 'Автомобіль',
  trailer: 'Причеп',
};

export const formBackList = {
  comment: '',
  description: '',
};

export const errMessageMoreThen = 'Поле має містити не менше 3-х символів';
